import React from 'react';
import GodtaBetingelser, { UserType } from './godtabetingelser';

const GodtaBetingelserPage = () => {
  return <GodtaBetingelser userType={UserType.Student} />;
};

export default GodtaBetingelserPage;
